import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostListener, OnInit, ViewEncapsulation } from '@angular/core';
import { MatCheckbox } from '@angular/material/checkbox';
import { Router, RouterLink } from '@angular/router';
import { CmsService, GlobalMessageService, GlobalMessageType, TranslatePipe, UrlPipe } from '@spartacus/core';
import { BREAKPOINT, BreakpointService } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import {
  GetPreferencesCodesPayload,
  MyaccountB2bunitService,
} from 'src/app/service/myaccount/myaccount-b2bunit.service';

@Component({
  selector: 'app-myaccount-edit-preferences',
  templateUrl: './myaccount-edit-preferences.component.html',
  styleUrls: ['./myaccount-edit-preferences.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [MatCheckbox, RouterLink, AsyncPipe, TranslatePipe, UrlPipe],
})
export class MyaccountEditPreferencesComponent implements OnInit {
  managedPreferences$: Observable<any>;
  myaccountAccountInfo$: Observable<any>;
  preferencesCodes$: Observable<any>;
  preferencesCodes: any = [];
  isMobile = false;
  cxMobileWidth = this.breakpointService.getSize(BREAKPOINT.sm);
  isBtnDisabled = true;
  defaultValues: any = [];

  managedPreferencesPayload: GetPreferencesCodesPayload = {
    fields: 'FULL',
    preferenceCodes: [],
  };
  constructor(
    protected cms: CmsService,
    private myaccountService: MyaccountB2bunitService,
    private router: Router,
    private messageService: GlobalMessageService,
    private breakpointService: BreakpointService
  ) {}

  ngOnInit() {
    this.isMobile = window.innerWidth < this.cxMobileWidth;
    this.cms
      .getCurrentPage()
      .pipe(take(1))
      .subscribe((data) => {
        if (data.label === '/my-account/edit-preferences') {
          this.myaccountAccountInfo$ = this.getUser(this.managedPreferencesPayload);
          this.myaccountAccountInfo$.pipe(take(1)).subscribe((items) => {
            this.preferencesCodes = items.preferences.enums;
            for (const key in this.preferencesCodes) {
              if (key !== null || key !== '') {
                this.managedPreferencesPayload.preferenceCodes.push(this.preferencesCodes[key].code);
                this.defaultValues.push(this.preferencesCodes[key].code);
              }
            }
          });
          this.managedPreferences$ = this.getManagementPreferences();
        }
      });
  }

  private getManagementPreferences(): Observable<any> {
    return this.myaccountService.getManagedPreferences();
  }

  private getUser(payload: any): Observable<any> {
    return this.myaccountService.getB2BUser(payload);
  }

  onChangeEventFunc(status: string, $event: any) {
    if ($event.checked) {
      this.managedPreferencesPayload.preferenceCodes.push(status);
    } else {
      const index = this.managedPreferencesPayload.preferenceCodes.indexOf(status);
      if (index > -1) {
        this.managedPreferencesPayload.preferenceCodes.splice(index, 1);
      }
    }

    const containsAll = (arr1: any, arr2: any) => arr2.every((arr2Item: any) => arr1.includes(arr2Item));
    const sameMembers = (arr1: any, arr2: any) => containsAll(arr1, arr2) && containsAll(arr2, arr1);

    if (sameMembers(this.defaultValues, this.managedPreferencesPayload.preferenceCodes)) {
      this.isBtnDisabled = true;
    } else {
      this.isBtnDisabled = false;
    }
  }

  onSubmit($event: any) {
    this.preferencesCodes$ = this.myaccountService.patchManagedPreferences(this.managedPreferencesPayload);
    this.preferencesCodes$.pipe(take(1)).subscribe((res) => {
      if (typeof res !== 'undefined') {
        if (res.type === 'userWsDTO') {
          this.router.navigateByUrl('/my-account');
          this.messageService.add(
            {
              key: 'myAccount.successEditPreferences',
            },
            GlobalMessageType.MSG_TYPE_CONFIRMATION
          );
        }
      }
    });
  }
  compareValue(notification: any, selected: any) {
    for (const key in notification) {
      if (key !== null) {
        for (const idx in selected) {
          if (idx !== null) {
            if (selected[idx].code === notification[key]) {
              return true;
            }
          }
        }
      }
    }
  }

  @HostListener('window:resize')
  onResize(): void {
    this.isMobile = window.innerWidth < this.cxMobileWidth;
  }
}
